import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PoolNotification } from '../models/pool-notification';

export interface SnackbarReducerState {
    notifications: PoolNotification[];
}

const initialState: SnackbarReducerState = {
    notifications: [],
};

const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        enqueue(state, action: PayloadAction<PoolNotification>) {
            state.notifications.push(action.payload);
        },
        remove(state, action: PayloadAction<number>) {
            state.notifications = state.notifications.filter(notification => notification.key !== action.payload);
        },
    },
});

export const { enqueue, remove } = snackbarSlice.actions;
export const { reducer, name } = snackbarSlice;
export type SnackbarSlice = { [name]: SnackbarReducerState };
